/**
 * Quem é suporte da Pontotel, para o front: `ehDeSuporte` ou e-mail com `lar21@`.
 *
 * É a régua que o front já usa em toda parte (MenuLateral, PainelDePontos,
 * MassChanges, LogDeOperacoes, ConfiguracoesAvancadas, SetupDeIntegracoes,
 * termosDeUso…): `includes`, não prefixo. Mora aqui para que uma tela nova não
 * invente a sua — a revisão do PR #3582 achou `/conexoes-mcp` com prefixo e o
 * menu com `includes`.
 *
 * É régua de EXIBIÇÃO: quem recusa de verdade é o backend. Onde ele é mais
 * estrito (a delegação MCP compara o prefixo), o pior caso aqui é mostrar a
 * tela e o backend responder 403 — nunca liberar o que ele nega.
 */
export interface IUsuarioQuePodeSerDeSuporte {
  ehDeSuporte?: boolean | null
  email?: string | null
}

export function ehUsuarioDeSuporte (usuario: IUsuarioQuePodeSerDeSuporte | null | undefined): boolean {
  if (!usuario) return false
  if (usuario.ehDeSuporte) return true
  return typeof usuario.email === 'string' && usuario.email.includes('lar21@')
}
